// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3wshF","disabled":"FileBtn_disabled__bcSek","warn":"FileBtn_warn__1sEu2","fade":"FileBtn_fade__3FUA2"};